
import { defineComponent, ref } from "vue";
import { getCSSVariableValue } from "../../assets/ts/_utils";
/* import { Home } from "@/store/enums/StoreEnums"; */
import { useStore } from "vuex";
import ApexCharts from "apexcharts";
import { convertToMoney } from "@/utils/stringUtils";

interface Data {
  name: string;
  data: number[];
}

export default defineComponent({
  name: "ChartTest",
  props: {
    widgetClasses: String,
  },
  emits: ["dataChange"],
  components: {},
  setup() {
    const labelColor = getCSSVariableValue("--bs-gray-500cc");
    const borderColor = getCSSVariableValue("--bs-gray-500");
    const baseColor = getCSSVariableValue("--bs-success");
    const secondaryColor = getCSSVariableValue("--bs-primary");
    const month = ref<string[]>([]);
    const store = ref(useStore());

    const options = ref({
      chart: {
        fontFamily: "inherit",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      legend: {
        show: true,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 5,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          style: {
            colors: labelColor,
            fontSize: "12px",
          },
        },
      },
      yaxis: [
        {
          labels: {
            style: {
              colors: labelColor,
              fontSize: "12px",
            },
            formatter: (value) => {
              return convertToMoney(value);
            },
          },
          tickAmount: 7,
          title: {
            text: "(vnd)",
            rotate: -45,
          },
        },
        {
          opposite: true,
          labels: {
            style: {
              colors: labelColor,
              fontSize: "12px",
            },
          },
          tickAmount: 7,
          title: {
            text: "(m3)",
            rotate: 45,
          },
        },
      ],
      fill: {
        opacity: 1,
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        hover: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "none",
            value: 0,
          },
        },
      },
      tooltip: {
        style: {
          fontSize: "12px",
        },
        y: [
          {
            formatter: function (val) {
              return convertToMoney(val.toString()) + " vnd";
            },
          },
          {
            formatter: function (val) {
              return convertToMoney(val.toString()) + " m3";
            },
          },
        ],
      },
      colors: [baseColor, secondaryColor],
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
    });
    const chart = ref<ApexCharts>();

    const series = ref<Data[]>([]);

    return {
      options,
      series,
      store,
      month,
      chart,
    };
  },
/*   methods: {
    handleFindRecent6MonthsData() {
      this.series = [] as Data[];
      this.store.dispatch(Home.findAppInfo).then((res) => {
        if (res.code == 200) {
          let data = JSON.parse(res.data);
          this.$emit("dataChange", res.data);
          const length = data.length;
          let i = 0;
          for (let prop in data[i]) {
            if (prop == "nThanhTien" || prop == "nSanLuong") {
              let name = "";
              let seriesData = { name: "", data: [] as number[] } as Data;
              switch (prop) {
                case "nThanhTien":
                  name = "Doanh Thu";
                  for (i = 0; i < length; i++) {
                    seriesData.data.push(
                      parseFloat(data[i][prop]) + parseFloat(data[i]["nVat"])
                    );
                  }
                  break;
                case "nSanLuong":
                  name = "Sản Lượng";
                  for (i = 0; i < length; i++) {
                    seriesData.data.push(data[i][prop]);
                  }
                  break;
                default:
                  name = "";
                  break;
              }
              seriesData.name = name;
              this.series.push(seriesData);
            } else if (prop == "cThang") {
              for (i = 0; i < length; i++) {
                let month = data[i][prop].split("/");
                if (!this.month.includes("Tháng " + parseInt(month[1])))
                  this.month.push("Tháng " + parseInt(month[1]));
              }
            }
            i = 0;
          }
          this.chart?.updateOptions({
            xaxis: {
              categories: this.month,
            },
          });
        }
      });
    },
  }, */
/*   mounted() {
    this.handleFindRecent6MonthsData();
  }, */
});
